import pl from './json/pl.json';
import en from './json/en.json';

class Data {
    static pl = pl;
    static en = en;
}

export default Data;